export default "__VITE_ASSET__D90OC4Nk__"